import { EventBus } from '@trutoo/event-bus';

// Fixes an issue with typings in event-bus
// More info on this workaround: https://github.com/facebook/jest/issues/11640#issuecomment-893867514
declare global {
  namespace NodeJS {
    interface Global {}
  }
}

export const ComponentEventBus = new EventBus();

(window as any).ComponentEventBus = ComponentEventBus;